import { stringify } from 'query-string';

import { setSessionRequestedHeaders } from 'actions/session';
import { cookieObjectToString } from 'helpers/Cookie';
import timedFetch from 'middleware/timedFetch';
import type { Cookies } from 'types/cookies';

export interface AmazonLinkedStyle {
  brandName: string;
  imageId: string;
  link: string;
  originalPrice: string;
  percentOff: string;
  price: string;
  productId: string;
  productName: string;
  productUrl: string;
  styleId: string;
}

export interface AmazonLinkedStylesResponse {
  linkedStyles: AmazonLinkedStyle[];
  productId: string;
}

interface GetAmazonLinkedStylesParams {
  limit?: number;
  productId: string;
  siteId?: number;
}

interface headerObj {
  [key: string]: string;
}

interface fetchOptsObj {
  credentials: string;
  headers: headerObj;
  method: string;
}

export const makeFetchOptions = function (cookies: Cookies) {
  const config: fetchOptsObj = {
    credentials: 'include', // only good for clientside
    headers: {
      Cookie: cookieObjectToString(cookies) // only good for serverside
    },
    method: 'GET'
  };

  return setSessionRequestedHeaders(config);
};

/**
 * Fetches Amazon-linked styles for a given Zappos product.
 * Calls GET https://beta-api.cloudcatalog.zappos.com/v1/amazonReverseShared/linkedStyles
 *
 * Passes session cookies for authentication, matching the Cloud Catalog productBundle pattern.
 * In kratos, the CloudCatalogHttpClient reads the AMAZON_SESSION_ID cookie and sends it
 * as an X_MAFIA_SESSION_ID header — marty's setSessionRequestedHeaders does the equivalent.
 */
export function getAmazonLinkedStyles(
  baseUrl: string,
  { limit = 10, productId, siteId = 1 }: GetAmazonLinkedStylesParams,
  fetcher = timedFetch('amazonReverseSharingLinkedStyles'),
  cookies: Cookies = {}
): Promise<Response<AmazonLinkedStylesResponse>> {
  const qs = stringify({ limit, productId, siteId });
  const fetchOpts = makeFetchOptions(cookies);
  return fetcher(`${baseUrl}/v1/amazonReverseShared/linkedStyles?${qs}`, fetchOpts);
}
